import { render } from "./DrugFactIndex.vue?vue&type=template&id=0be9ef58"
import script from "./DrugFactIndex.vue?vue&type=script&lang=js"
export * from "./DrugFactIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__